import { API } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';
import { ResponseBase } from '~types/response';

interface Response extends ResponseBase {
  data: {
    email: string;
  };
}

/**
 * 비밀번호 변경 시 이메일 인증코드를 payload의 이메일로 전송
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/password-controller/requestReset
 */
export default function postRequestResetPasscode(data: AuthModel.PasscodeRequest) {
  return API.post<Response>('/api/v2/users/password/request-reset', { data });
}
